import { readLocalStorage } from "../utils/readLocalStorage";
import { useCallback } from "react";
import { useState } from "react";
import { writeLocalStorage } from "../utils/writeLocalStorage";

/**
 * This custom hook is responsible for providing read and write access to the local storage for a specific {@link key}.
 */
export const useLocalStorage = <T>(
  key: string,
  fallbackValue: T
): [value: T, updateValue: (newValue: T) => void] => {
  const [value, setValue] = useState<T>(
    readLocalStorage(key) ?? writeLocalStorage(key, fallbackValue)
  );

  const updateValue = useCallback(
    (newValue: T) => {
      writeLocalStorage(key, newValue);
      setValue(newValue);
    },
    [key]
  );

  return [value, updateValue];
};
